import React from 'react';
// import { Col, Row, Container } from 'reactstrap';

import { Layout } from '../../components';
import { Banner, Counter, About, Services, InvestmentPlans, Management } from '../../components/Home';

import growthImg from '../../images/wcu/Growth.png';
import referalImg from '../../images/wcu/Referal.png';
import secureImg from '../../images/wcu/secure.png';

function Home() {
  return (
    <Layout>
      <Banner />
      <Counter />
      <About />

      {/* <!-- we think global begin--> */}
      <div className="we-think-global">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-6 col-lg-6 col-md-10">
              <div className="part-left text-center">
                <h2>
                  We were always
                  <br />
                  thinking global Community
                </h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do Ut enim ad minim veniam. Quis nostrud
                  exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                  voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
                <a href="index.html#">Learn More</a>
              </div>
            </div>

            {/* <div className="col-xl-6 col-lg-6 col-md-10 d-flex align-items-center">
              <div className="part-right">
                <h3>Start Invest Now</h3>
                <p>
                  Quis nostrud exercitation ullamco laboris nisi utaliquip commodo consequat. Duis aute feeirure dolor
                  voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
                <a href="index.html#">View Plans</a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* <!-- we think global end--> */}

      {/* <!-- choosing resons begin--> */}
      <div className="choosing-reason">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-8">
              <div className="section-title">
                <h2>Why choose us</h2>
                <p>
                  We believe that our clients' success is our business concern; so, we operate using sound professional
                  ethics consistent with international standards, that which has been of immense help in maintaining
                  sound financial decision on behalf of our clients & partners.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="single-reason text-center">
                <div className="part-img">
                  <img src={growthImg} alt="" />
                </div>
                <div className="part-text">
                  <h3>Profitable</h3>
                  <p>
                    We have Invested & managed over $280,000.00 in Real Estate, Export, Investment & portfolio
                    management, Credit & Loan facility. We have over 110 growing Investors & Clients.{' '}
                  </p>
                  {/* <a href="index.html#">Read More</a> */}
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="single-reason text-center">
                <div className="part-img">
                  <img src={secureImg} alt="" />
                </div>
                <div className="part-text">
                  <h3>Stable & Secure</h3>
                  <p>
                    We have never lost any invested fund, as such we and our investors & partners take great pride in
                    that.
                  </p>
                  {/* <a href="index.html#">Read More</a> */}
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="single-reason text-center">
                <div className="part-img">
                  <img src={referalImg} alt="" />
                </div>
                <div className="part-text">
                  <h3>Referral Provides</h3>
                  <p>
                    Effective business support planning becomes one of the most critical activities within successful
                    small business maintenance and development.Accure provides best affordable plan to earn money.
                  </p>
                  {/* <a href="index.html#">Read More</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- choosing resons end--> */}

      <Services />
      <InvestmentPlans />
      <Management />
    </Layout>
  );
}

export default Home;
